<template>
    <input type="hidden" name="_token" :value="token" />
</template>

<script setup>
import { ref, onMounted } from 'vue'

const token = ref(null)

onMounted(() => {
    const meta = document.head.querySelector('meta[name="csrf-token"]')
    token.value = meta?.content ?? ''
})
</script>
